import {
  filter as filterLodash,
  get,
  includes,
  isArray,
  isEmpty,
  map,
  size,
} from 'lodash'
import moment from 'moment'
import React from 'react'

import Button from '../../Button'
import {
  BasePropsInfinity,
  IField,
  IFilter,
  TFilterState,
  TFilterType,
} from '../types'

interface FilterLabelProps extends BasePropsInfinity, TFilterState {
  removeFilter: (val: string, type: TFilterType) => void
  filterLabelVariant: string
}

export const arraySlicer = (array: string[], lastSeparator: string): string => {
  if (size(array) === 1) {
    return array[0]
  }
  return array.slice(0, -1).join(', ') + ` ${lastSeparator} ` + array.slice(-1)
}

const FilterLabel = (props: FilterLabelProps): React.ReactElement => {
  const { filter, ui, filterClean, filterLabelVariant, removeFilter } = props

  if (get(ui, 'isDetailOpen', false) || isEmpty(filter) || !isArray(filter)) {
    return <></>
  }

  const filterCleanWithoutNull: Array<IField> = filterLodash(
    get(filterClean, 'filter', []),
    (item) =>
      item.value !== null || item.value !== undefined || item.value !== '', //!lodash.isEmpty(item.value),
  ) as Array<IField>

  if (isEmpty(filterCleanWithoutNull)) {
    return <></>
  }

  let valuesFilter: {
    [key: string]: string
  }[] = []

  const currentFilter: IFilter[] = filter.filter((item) => {
    const { options = [] } = item
    const indexFilter: number = filterCleanWithoutNull.findIndex(
      (itemClean: { field: string; value: any }) => {
        if (itemClean.field === item.name) {
          const nameItem = item.name

          if (item.type === 'threeSidedBoolean') {
            if (itemClean.value === 'unrestricted') {
              return false
            }
            const labelOption = options.find(
              (opt) => opt.value === itemClean.value,
            )
            valuesFilter = { ...valuesFilter, [nameItem]: labelOption?.label }
            return true
          }

          if (item.type === 'multiValue') {
            const labelOptions = options.filter((opt) =>
              includes(itemClean.value, opt.value),
            )

            if (labelOptions.length === 0) {
              return false
            } else {
              valuesFilter = {
                ...valuesFilter,
                [nameItem]: arraySlicer(
                  map(labelOptions, (option) => option.label),
                  '&',
                ),
              }

              return true
            }
          }

          if (item.type === 'checkbox') {
            if (itemClean.value === false) {
              return false
            }

            valuesFilter = {
              ...valuesFilter,
              [item.name]: i18n.t('active_filter_bool', 'Aktiv'),
            }
            return true
          }

          if (item.name === 'fulltext') {
            return false
          }

          if (item.type === 'multiValue') {
            const labelOption = itemClean.value.map((value) => {
              return get(
                options.find((opt) => opt.value === value),
                'label',
              )
            })
            valuesFilter = { ...valuesFilter, [nameItem]: labelOption }
            return true
          }

          if (item.type === 'daterange') {
            const { startDate, endDate } = itemClean.value || {}
            const dateFormat = item.hideTimePicker
              ? 'DD.MM.YYYY'
              : 'DD.MM.YYYY HH:mm'
            const labelOption = `${moment(startDate).format(
              dateFormat,
            )} - ${moment(endDate).format(dateFormat)}`
            valuesFilter = { ...valuesFilter, [nameItem]: labelOption }
            return true
          }

          if (item.type === 'select') {
            const labelOption = options.find((opt) =>
              includes(itemClean.value, opt.value),
            )
            if (!labelOption) {
              return false
            }
            valuesFilter = { ...valuesFilter, [nameItem]: labelOption.label }
            return true
          }

          valuesFilter = { ...valuesFilter, [nameItem]: itemClean.value }
          return true
        }
        return false
      },
    )
    return indexFilter >= 0
  })
  return (
    <div className="mt-1 mb-1">
      {currentFilter.map((item, key) => {
        const { name = '', type = '' } = item
        return (
          <Button
            key={key}
            className="mr-1 mb-1"
            size="xs"
            variant={filterLabelVariant}
            onClick={() => removeFilter(name, type)}
          >
            <span className="font-weight-bold mx-1">{`${item.label}:`} </span>
            <span>{`${
              isArray(valuesFilter[name])
                ? valuesFilter[name].join(', ')
                : valuesFilter[name]
            }`}</span>{' '}
            <i className="fa fa-times ml-2" />
          </Button>
        )
      })}
    </div>
  )
}

export default FilterLabel
